import React from "react";
import "./Cultural.css";
import history from "../../img/about/history.png";

function Cultural() {
  return (
    <div className="Cultural">
      <div className="Cultural__mobile__img">
        <img src={history} alt="Luxury villa with sea view in Costa Blanca, Spain" />
      </div>
      <div className="Cultural__img">
        <img src={history} alt="Luxury villa with sea view in Costa Blanca, Spain" />
      </div>
      <div className="Cultural__txt">
        <h1>Cultural Offer</h1>
        <p>
          Immerse yourself in the vibrant cultural scene of Costa Blanca, where
          ancient traditions blend harmoniously with modern artistry. Explore
          historic landmarks such as the imposing Castle of Santa Bárbara in
          Alicante or wander through the charming old towns of Altea and
          Villajoyosa, each adorned with colorful facades and cobblestone
          streets.
          <br />
          <br />
          From lively festivals celebrating local customs to world-class museums
          showcasing avant-garde exhibits, Costa Blanca's cultural diversity
          never ceases to enchant.
        </p>
      </div>
    </div>
  );
}

export default Cultural;
